import React from 'react';

class SoilResult extends React.Component{
    static defaultProps = {
        soilType: 'potgrond'
    }

    constructor(props){
        super(props);
    }

    render(){
        let m3 = this.props.m3;
        let liters = 980 * m3;
        let bags = Math.ceil(liters / 40);
        let potText = '';
        if (this.props.soilType == 'Potgrond'){
            potText =
                <li>
                    De inhoud van deze pot is is <strong>{Math.round((m3 + Number.EPSILON) * 100 ) / 100} m3</strong>.
                </li>;
        }
        return <div className="soil-results">
            <h3>Benodigde {this.props.soilType}</h3>
            <ul>
                {potText}
                <li>
                    U heeft ongeveer <strong>{Math.round(liters)} liter {this.props.soilType}</strong> nodig.
                </li>
                <li>
                    U heeft dus voldoende {this.props.soilType} bij aanschaf van <strong>{bags} zakken {this.props.soilType} van 40 liter</strong>.
                </li>
            </ul>
        </div>
    }
}

export default SoilResult;